import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// Oggi — New-customers campaign (adc_j84ryry3vm), the advertiser's only
// campaign. Real lifetime aggregates from
// ANALYTICS.ADS_SNAPSHOTS.MANAGER_METRICS_CAMPAIGN_PERIODS (complete months
// Nov 2025 – Jul 2026). The current run started Jan 3, 2026; the Nov–Dec 2025
// periods are from its previous run and are kept in the series. Monthly series
// lives in realBrandData.ts.
export const campOgNew: FaireAdCampaignEntity = {
  token: "camp_og_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_oggi",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 525,
  startedRunningAt: "2026-01-03",
  scheduledStartDate: "2026-01-03",
  segmentMetrics: {
    numCustomersAcquired: 38,
    salesDollars: 18938,
    totalAdsSpendDollars: 2864,
    cpaDollars: 75,
    bestEstimateSalesDollars: 18938,
    bestEstimateRoas: 6.61,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-19T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
